import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  getPaySettingAction,
  getSensitiveAction,
  operationRecordAction,
  getSilverCoinDetailsAction,
  versionConfigAction,
  updateVersionConfigAction,
  deleteVersionConfigAction,
  createVersionConfigAction,
  getWorldChatAdminAction,
  setWorldChatAdminsAction,
  deleteWorldChatAdminsAction
} from "../action/paySettingAction";

export const paySettingReducer = (
  builder: ActionReducerMapBuilder<{
    paySettingList: string;
    sensitiveList: any;
    operationRecordList: any,
    getSilverCoinDetailsConfig: any,
    versionConfig: any,
    deleteVersionConfig: any,
    updateVersionConfig: any,
    createVersionConfig: any,
    getWorldChatAdminConfig: any,
    setWorldChatAdminsConfig: any,
    deleteWorldChatAdminsConfig: any
  }>
) => {
  builder.addCase(getPaySettingAction.fulfilled, (state, { payload }) => {
    state.paySettingList = payload;
  });
  builder.addCase(getSensitiveAction.fulfilled, (state, { payload }) => {
    state.sensitiveList = payload;
  });
  builder.addCase(operationRecordAction.fulfilled, (state, { payload }) => {
    state.operationRecordList = payload
  })
  builder.addCase(getSilverCoinDetailsAction.fulfilled, (state, { payload }) => {
    state.getSilverCoinDetailsConfig = payload
  })
  builder.addCase(versionConfigAction.fulfilled, (state, { payload }) => {
    state.versionConfig = payload
  })
  builder.addCase(createVersionConfigAction.fulfilled, (state, { payload }) => {
    state.createVersionConfig = payload
  })
  builder.addCase(updateVersionConfigAction.fulfilled, (state, { payload }) => {
    state.updateVersionConfig = payload
  })
  builder.addCase(deleteVersionConfigAction.fulfilled, (state, { payload }) => {
    state.deleteVersionConfig = payload
  })
  builder.addCase(getWorldChatAdminAction.fulfilled, (state, { payload }) => {
    state.getWorldChatAdminConfig = payload
  })
  builder.addCase(setWorldChatAdminsAction.fulfilled, (state, { payload }) => {
    state.setWorldChatAdminsConfig = payload
  })
  builder.addCase(deleteWorldChatAdminsAction.fulfilled, (state, { payload }) => {
    state.deleteWorldChatAdminsConfig = payload
  })
};
